import React, { ReactNode, createContext, useContext, useState } from 'react';
import { CommunitySlugMap } from 'src/mainTypes';
import { PropsCommunity } from '../types';

type CommunityDetailsContextProps = {
  community: PropsCommunity;
  openInputMarkdown: boolean;
  setCommunity: (community: PropsCommunity) => void;
  setOpenInputMarkdown: (openInputMarkdown: boolean) => void;
  communitiesSlugMap: CommunitySlugMap[];
  setCommunitiesSlugMap: (communitiesSlugMap: CommunitySlugMap[]) => void;
};

type CommunityContextProviderProps = {
  children: ReactNode;
};

const CommunityDetailsContext = createContext<CommunityDetailsContextProps>(
  {} as CommunityDetailsContextProps
);

export const CommunityDetailsProvider = ({ children }: CommunityContextProviderProps) => {
  const [community, setCommunity] = useState<PropsCommunity>({} as PropsCommunity);
  const [communitiesSlugMap, setCommunitiesSlugMap] = useState<CommunitySlugMap[]>([]);
  const [openInputMarkdown, setOpenInputMarkdown] = useState<boolean>(false);

  return (
    <CommunityDetailsContext.Provider
      value={{
        community,
        setCommunity,
        openInputMarkdown,
        setOpenInputMarkdown,
        communitiesSlugMap,
        setCommunitiesSlugMap
      }}
    >
      {children}
    </CommunityDetailsContext.Provider>
  );
};

export const useCommunityDetails = () => {
  const context = useContext(CommunityDetailsContext);

  return context;
};
